import type { FormType } from "./types";

/** Hard cap from the spec — also enforced server-side as MAXFORMSPERREVIEWTEMPLATE. */
export const MAX_FORMS_PER_TYPE = 100;

export const STEP_ID = "add-forms";
export const STEP_TITLE = "Add Forms";

export const TAB_LABELS: Record<FormType, string> = {
	standard: "Forms",
	"360": "360 Forms",
	external: "External Forms",
};

export const NO_TEMPLATE_BANNER = "Please select a review template to continue.";
export const TEMPLATE_NO_ACTIVE_FORMS_BANNER = "This template has no active forms, please select another.";
export const TEMPLATE_REQUIRED_ERROR = "This is a required field";
